import { useQuery } from "react-query";
import axios from "src/utils/axiosInstance";
import { baseUrl_V2 } from "src/utils/config";

// due FinaTable pagination issue, page and size are hardcoded for later to fix
const fetchTransactions = (pageNumber, pageSize) =>
  axios.get(`${baseUrl_V2}/dashboard/transactions`, {
    params: {
      page_number: 1,
      page_size: 1000,
    },
  });

const useTransactions = (pageNumber, pageSize) =>
  useQuery({
    /* Not keyed on the page: the request above ignores both arguments and
       always asks for the first thousand, so keying on them only split the
       cache and fetched the same rows again — once for the transactions tab
       and once for anything else reading them. */
    queryKey: ["/transactions"],
    queryFn: () => fetchTransactions(pageNumber, pageSize),
    refetchOnWindowFocus: false,
  });

export default useTransactions;
